import React from 'react';
import DesktopMenu from 'on_web/components/shared/Menu/DesktopMenu/DesktopMenu';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import Header from 'on_web/components/shared/Menu/Header/Header';
import { useTranslation } from 'react-i18next';
import { mapRoutesToMenuItems } from 'on_web/helpers/menuItems';
import { getUserMetadata } from 'on_web/pce_legacy/src/helpers/clientStorageHelper';
import ReportsBottomNavigation from 'on_web/components/shared/ReportsBottomNavigation/ReportsBottomNavigation';
import PageContainer from 'on_web/components/shared/Common/PageContainer/PageContainer';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

export default function AssessmentPage(props) {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div style={{ display: 'flex' }}>
      {/* Menu visible on Desktop resolutions */}
      {props.noDesktopSupport !== true && (
        <DesktopMenu
          id={props.desktopMenuIndex}
          stateToTransferOnNavigation={props.stateToTransfer}
        />
      )}

      <PageContainer noDesktopSupport={props.noDesktopSupport}>
        <PageItemContainer>
          {/* Header visible on Mobile resolutions */}
          <Header
            squeeze
            title={props.headerMenuText}
            primaryHeader={props.primaryHeader}
            secondaryHeader={props.secondaryHeader}
            secondaryHeaderWithBackNavigation={
              props.secondaryHeaderWithBackNavigation
            }
            hasShareAction={props.hasShareAction}
            mainMenuItems={t('common.menu.mainItems', {
              returnObjects: true,
            })}
            extraMenuItems={mapRoutesToMenuItems(getUserMetadata())}
            noDesktopSupport={props.noDesktopSupport}
            stateToTransferOnNavigation={props.stateToTransfer}
          />

          {/* Start content of the page */}
          <div style={{ paddingLeft: '11px', paddingRight: '11px' }}>
            {props.children}
          </div>
          {/* End content of the page */}

          {/* Bottom menu on Mobile resolutions */}
          {props.hideBottomNavigation !== true && (
            <ReportsBottomNavigation
              selected={props.bottomMenuSelectedOptionCode}
              onSelected={val =>
                history.push({
                  pathname: val,
                  state: props.stateToTransfer,
                })
              }
            />
          )}
        </PageItemContainer>
      </PageContainer>
    </div>
  );
}

AssessmentPage.propTypes = {
  /**
   * Text for the page in header menu.
   */
  headerMenuText: PropTypes.string.isRequired,

  /**
   * Code for the bottom menu option that needs to be selected
   */
  bottomMenuSelectedOptionCode: PropTypes.string.isRequired,

  /**
   * Index of the page in desktop menu.
   */
  desktopMenuIndex: PropTypes.number.isRequired,

  /**
   * Indicates whether header on mobile is of type second level header.
   */
  secondaryHeader: PropTypes.bool,

  /**
   * Indicates whether header on mobile is of type second level header with back navigation.
   */
  secondaryHeaderWithBackNavigation: PropTypes.bool,

  /**
   * Indicates whether share CTA need to be visible.
   */
  hasShareAction: PropTypes.bool,
};
